export default __webpack_public_path__ + "static/media/icon-add-to-library.e9a2ff5f.svg";